exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\r\n    max-height: 60vh;\r\n    overflow-y: auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.component.css
// module id = ../../../../../src/app/pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.component.css
// module chunks = main